const ProcessHistoryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        defaultFilter: false,
        sortable: false,
        width: 60
    },
    {
        name: 'Number',
        code: 'serialNumber',
        column: true,
        align: "center",
        width: 120,
        defaultFilter: false,
        sortable: false,
        listFilter: false
    },
    // {
    //     name: 'GR WEIGHT',
    //     code: 'grWeight',
    //     align: "center",
    //     column: true,
    //     width: 100,
    //     defaultFilter: false,
    //     sortable: false,
    //     listFilter: false
    // },
    {
        name: 'PO',
        code: 'po',
        column: true,
        align: "center",
        sortable: false,
        width: 100,
        defaultFilter: false,
        listFilter: false
    },
    {
        name: 'Style',
        code: 'style',
        align: "center",
        width: 80,
        column: true,
        defaultFilter: false,
        sortable: false,
        listFilter: false
    },
    // {
    //     name: 'Print',
    //     code: 'print',
    //     width: 80,
    //     align: "center",
    //     column: true,
    //     defaultFilter: false,
    //     sortable: false,
    //     listFilter: false
    // },
    {
        name: 'Col',
        code: 'col',
        column: true,
        align: "center",
        width: 80,
        defaultFilter: false,
        sortable: false,
        listFilter: false
    },
    {
        name: 'Size',
        code: 'size',
        column: true,
        width: 80,
        defaultFilter: false,
        sortable: false,
        listFilter: false,
        align: 'center'
    },
    {
        name: 'QUANTITY',
        code: 'quantity',
        column: true,
        width: 100,
        defaultFilter: false,
        sortable: false,
        align: "center",
        listFilter: false
    },
    {
        name: 'Operator',
        code: 'operator',
        column: true,
        width: 100,
        defaultFilter: false,
        sortable: false,
        align: "center",
        listFilter: false
    },
    {
        name: 'Scan Time',
        code: 'scanTime',
        column: true,
        align: "center",
        width: 150,
        defaultFilter: false,
        sortable: false,
        listFilter: false
    },
    {
        name: 'Match',
        code: 'match',
        column: true,
        align: "center",
        width: 80,
        defaultFilter: false,
        sortable: false,
        listFilter: false
    }
];
export default ProcessHistoryFields;
